import I18n from 'I18n';
import { CALL_TYPE_ID, CART_TYPE_ID, COMPANY_TYPE_ID, CONTACT_TYPE_ID, DEAL_TYPE_ID, ORDER_TYPE_ID, COMMERCE_PAYMENT_TYPE_ID, PAYMENT_LINK_TYPE_ID, TICKET_TYPE_ID, INVOICE_TYPE_ID, QUOTE_TYPE_ID, CAMPAIGN_TYPE_ID, SUBSCRIPTION_TYPE_ID, CONTRACT_TYPE_ID, MEETING_EVENT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
export function getSearchPlaceholderText(objectTypeId) {
  switch (objectTypeId) {
    case CALL_TYPE_ID:
      return I18n.text('cardAssociatedObjects.searchBar.placeholders.calls');
    case CONTACT_TYPE_ID:
      return I18n.text('cardAssociatedObjects.searchBar.placeholders.contact');
    case COMPANY_TYPE_ID:
      return I18n.text('cardAssociatedObjects.searchBar.placeholders.company');
    case DEAL_TYPE_ID:
      return I18n.text('cardAssociatedObjects.searchBar.placeholders.deal');
    case TICKET_TYPE_ID:
      return I18n.text('cardAssociatedObjects.searchBar.placeholders.tickets');
    case ORDER_TYPE_ID:
      return I18n.text('cardAssociatedObjects.searchBar.placeholders.orders');
    case CART_TYPE_ID:
      return I18n.text('cardAssociatedObjects.searchBar.placeholders.carts');
    case COMMERCE_PAYMENT_TYPE_ID:
      return I18n.text('cardAssociatedObjects.searchBar.placeholders.payments');
    case INVOICE_TYPE_ID:
      return I18n.text('cardAssociatedObjects.searchBar.placeholders.invoices');
    case PAYMENT_LINK_TYPE_ID:
      return I18n.text('cardAssociatedObjects.searchBar.placeholders.paymentLink');
    case QUOTE_TYPE_ID:
      return I18n.text('cardAssociatedObjects.searchBar.placeholders.quotes');
    case CAMPAIGN_TYPE_ID:
      return I18n.text('cardAssociatedObjects.searchBar.placeholders.campaigns');
    case SUBSCRIPTION_TYPE_ID:
      return I18n.text('cardAssociatedObjects.searchBar.placeholders.subscriptions');
    case CONTRACT_TYPE_ID:
      return I18n.text('cardAssociatedObjects.searchBar.placeholders.contracts');
    case MEETING_EVENT_TYPE_ID:
      return I18n.text('cardAssociatedObjects.searchBar.placeholders.meetings');
    default:
      return I18n.text('cardAssociatedObjects.searchBar.placeholders.default');
  }
}